<template>
    <el-drawer
    :visible.sync="visible"
    direction="btt"
    size="90%"
    :title="email.subject"
    :append-to-body="true"
    :destroy-on-close="true"
    :with-header="true"
    :close-on-press-escape="false"
    :modal="true"
    :before-close="handleClose"
    custom-class="compose-email-drawer"
  >
    <div class="mbl-drawer">
        <div class="mbl-info">
            <div class="info-row">
                <span class="info-label">发件人：</span>
                <span class="info-value">
                <template v-if="email.sender.address != email.sender.name">{{ email.sender.name }}&lt;</template>{{ email.sender.address }}<template v-if="email.sender.address != email.sender.name">&gt;</template>
                </span>
                <span class="info-label ml-20">发送时间：</span>
                <span class="info-value">{{ email.receivedDate }}</span>
            </div>
            <div class="info-row">
                <span class="info-label">收件人：</span>
                <span class="info-value">{{ email.recipients.map(e => e.address).join('、') }}</span>
            </div>
            <div v-if="email.cc && email.cc.length" class="info-row">
                <span class="info-label">抄送：</span>
                <span class="info-value">{{ email.cc.map(e => e.address).join('、') }}</span>
            </div>
            <div v-if="email.attachments && email.attachments.length" class="info-row attachments-row">
                <span class="info-label">附件：</span>
                <div class="attachment-list">
                <div v-for="(file, idx) in email.attachments" :key="idx" class="attachment-tag" @click.stop="downLoad(file)">
                    <svg-icon v-if="file.fileName.split('.').pop().toLowerCase() == 'pdf'" iconClass="pdf" className="icon"></svg-icon>
                    <svg-icon v-else-if="file.fileName.split('.').pop().toLowerCase() == 'xlsx'" iconClass="xlsx" className="icon"></svg-icon>
                    <i v-else class="el-icon-document" />
                    <span>{{ file.fileName }}</span>
                    <i class="el-icon-download" />
                </div>
                </div>
            </div>
        </div>
        <div class="mbl-info-body" v-html="email.content"></div>
    </div>
</el-drawer>
</template>

<script>

import {downLoadEmailFile} from '@/api/email' 
export default {
  name: 'ComposeEmailDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    email: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    async downLoad(file) {
      try {
        const res = await downLoadEmailFile({ guid: file.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-drawer__header {
  border-bottom: none;
}
.mbl-drawer {
    display: flex;
    flex-direction: column;
    height: 100%;
    .mbl-info{
        border-top:none;
        border-left:none;
        border-right:none;
        border-radius: 0;
    }
    .mbl-info-body{
        padding:20px;
        flex:1;
        overflow: auto;
    }

    .info-label{
        color: #666;
    }
}
</style>